"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorHandleAWSSDK = exports.ErrorHandleAPI = void 0;
function ErrorHandleAPI(error) {
    if (!!error && !!error.code && !!error.errorCode && !!error.errorMessage) {
        return {
            error: true,
            code: error.code,
            errorMessage: error.errorMessage,
            errorCode: error.errorCode
        };
    }
    if (!!error && !!error.name && error.name === "EntityNotFound" && !!error.message) {
        return {
            error: true,
            code: 404,
            errorCode: "EntityNotFound",
            errorMessage: error.message
                .replace(/\n/g, "")
                .replace(/\"/g, "'")
                .replace(/\s\s+/g, " ")
        };
    }
    return {
        error: true,
        code: 500,
        errorCode: "UnknownError",
        errorMessage: "Unknown error occurred"
    };
}
exports.ErrorHandleAPI = ErrorHandleAPI;
function ErrorHandleAWSSDK(error, defaultCode, defaultErrorCode, defaultErrorMessage) {
    if (!!error.statusCode && !!error.message && !!error.code) {
        return {
            code: error.statusCode,
            errorMessage: error.message,
            errorCode: error.code
        };
    }
    return {
        code: defaultCode,
        errorCode: defaultErrorCode,
        errorMessage: defaultErrorMessage
    };
}
exports.ErrorHandleAWSSDK = ErrorHandleAWSSDK;
//# sourceMappingURL=DomainError.js.map